var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SuccessAlert animated fadeInRight",class:{ fadeOutRight: _vm.hide, hidden: _vm.hidden }},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v("   Gemt\n")])}
var staticRenderFns = []

export { render, staticRenderFns }